import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";

import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { CardButtonBackground, CardButtonSize } from "./card-button.model";

import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-card-button",
  templateUrl: "./card-button.component.html",
  styleUrls: ["./card-button.component.scss"],
  imports: [FontAwesomeModule, CommonModule, TranslateModule],
  standalone: true,
})
export class CardButtonComponent {
  @Input() disabled: boolean = false;
  @Input() buttonSize: CardButtonSize = CardButtonSize.Normal;
  @Input() buttonBackground: CardButtonBackground = CardButtonBackground.Primary;
  @Input() buttonIcon: [IconPrefix, IconName];
  @Input() warning: boolean = false;

  @Output() clicked = new EventEmitter<void>();

  //CardButtonBackground

  getButtonSize() {
    const buttonClass = "card-button--";

    switch (this.buttonSize) {
      case CardButtonSize.Long:
        return `${buttonClass}long`;
      case CardButtonSize.Normal:
        return `${buttonClass}normal`;
      case CardButtonSize.Small:
        return `${buttonClass}small`;
      case CardButtonSize.Smaller:
        return `${buttonClass}smaller`;
      case CardButtonSize.Box:
        return `${buttonClass}box`;
      case CardButtonSize.Inline:
        return `${buttonClass}inline`;
      default:
        return `${buttonClass}normal`;
    }
  }

  getButtonBackground() {
    const buttonClass = "card-button--";

    switch (this.buttonBackground) {
      case CardButtonBackground.Primary:
        return `${buttonClass}primary`;
      case CardButtonBackground.Secondary:
        return `${buttonClass}secondary`;
      case CardButtonBackground.Tertiary:
        return `${buttonClass}tertiary`;
      case CardButtonBackground.Danger:
        return `${buttonClass}danger`;
      case CardButtonBackground.DangerSecondary:
        return `${buttonClass}danger-secondary`;
      default:
        return `${buttonClass}primary`;
    }
  }

  onClick() {
    if (!this.disabled) this.clicked.emit();
  }
}
